import { ILayout, ILayoutMetrics } from './ILayout';
import { ISize } from './ISize';

export class ListLayout implements ILayout {

  public static DefaultRowHeight = 38; // should match $dataGridRowHeight in sizes.styl

  private rowHeight: number;

  constructor(rowHeight: number = ListLayout.DefaultRowHeight) {
    this.rowHeight = rowHeight;
  }

  public metrics(dimensions: ISize): ILayoutMetrics {
    return {
      numberOfRows: Math.max(Math.ceil(dimensions.height / this.rowHeight), 1),
      numberOfCols: 1,
      heightOfRowInPx: this.rowHeight
    };
  }

}
